/**
 * 研学商旅相关
 */

import {localget} from './storage'
import consts from "Utils/consts";
import {YX_CONFIG} from 'Config/index'

export function isYx() {
  const param = localget(consts.thirdChannelParam)
  if (!param) {
    return false
  } else {
    return 'yx' === param.accessChannel
  }
}

export function goYxHome() {
  window.location.href = YX_CONFIG.yxBackUrl
}
